<template>
  <div class="ml-auto py-2 pl-2 bg-dark">
    <div class="w-100 d-flex justify-content-end">
      <template v-if="mediaType != 'category'">
        <b-dropdown variant="link" class="">
          <template slot="button-content">
            <span class="mr-2">
              <span class="mx-2">File</span>
            </span>
          </template>

          <b-dropdown-text>Add new...</b-dropdown-text>


          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'artist_page'})">
            <Icon2 icon="Menu_Categories"/>
            <span class="ml-1 px-2 py-1">Artist Page</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'audio'})">
            <Icon2 icon="Menu_audio"/>
            <span class="ml-1 px-2 py-1">Audio</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'book'})">
            <Icon2 icon="Menu_books"/>
            <span class="ml-1 px-2 py-1">Book</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'brand'})">
            <Icon2 icon="Menu_Brands"/>
            <span class="ml-1 px-2 py-1">Brand</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'external'})">
            <Icon2 icon="Menu_externals"/>
            <span class="ml-1 px-2 py-1">External</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'magazine'})">
            <Icon2 icon="Menu_Magazines"/>
            <span class="ml-1 px-2 py-1">Magazine</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'page'})">
            <Icon2 icon="Menu_Categories"/>
            <span class="ml-1 px-2 py-1">Micropage</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'music_album'})">
            <Icon2 icon="Menu_music"/>
            <span class="ml-1 px-2 py-1">Music Album</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'photo_package'})">
            <Icon2 icon="Menu_camera"/>
            <span class="ml-1 px-2 py-1">Photo Package</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'playlist_page'})">
            <Icon2 icon="Menu_Categories"/>
            <span class="ml-1 px-2 py-1">Playlist Page</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'podcast'})">
            <Icon2 icon="Menu_podcast"/>
            <span class="ml-1 px-2 py-1">Podcast</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'series'})">
            <Icon2 icon="Menu_Series"/>
            <span class="ml-1 px-2 py-1">Series</span>
          </b-dropdown-item>
          <b-dropdown-item href="#" @click="$store.dispatch('media/addNewItem', {type: 'video'})">
            <Icon2 icon="Menu_Videos"/>
            <span class="ml-1 px-2 py-1">Video</span>
          </b-dropdown-item>

          <b-dropdown-divider/>

          <b-dropdown-item id="import-button" text="Import" @click="$store.commit('media/updateModal', {import: {visible: true, insert: false}})">
            <Icon2 icon="import"/>
            <span class="ml-2">Import from Excel</span>
          </b-dropdown-item>

          <b-dropdown-item id="export-button" text="Export" @click="$root.$emit('media-export', true)">
            <Icon2 icon="export"/>
            <span class="ml-2">Export to Excel</span>
          </b-dropdown-item>

          <b-dropdown-divider/>

          <b-dropdown-item v-if="$config.allowInsertFromExcel" id="import-new-button" text="Import New" @click="$store.commit('media/updateModal', {import: {visible: true, insert: true}})">
            <Icon2 icon="import"/>
            <span class="ml-2">Import new content from Excel</span>
          </b-dropdown-item>

        </b-dropdown>


        <b-dropdown variant="link" class="">
          <template slot="button-content">
            <span class="mr-2">
              <span class="mx-2">Edit</span>
            </span>
          </template>

          <b-dropdown-item id="duplicate-button" text="Duplicate" @click="handleDuplicate">
            <Icon2 icon="Copy_id"/>
            <span class="ml-2">Duplicate</span>
          </b-dropdown-item>

          <b-dropdown-item @click="handleArchive">
            <Icon2 icon="Archive"/>
            <span class="ml-2">Archive</span>
          </b-dropdown-item>

          <b-dropdown-item @click="manageMediaLabels">
            <font-awesome-icon icon="tags"/>
            <span class="ml-2">Manage Labels</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="$config.enableArtistsEverywhere" @click="manageMediaArtists">
            <font-awesome-icon icon="user"/>
            <span class="ml-2">Manage Artists</span>
          </b-dropdown-item>

          <b-dropdown-item v-if="$config.enableGenres" @click="manageMediaGenres">
            <font-awesome-icon icon="tags"/>
            <span class="ml-2">Manage Genres</span>
          </b-dropdown-item>

          <b-dropdown-item @click="manageMediaProperties">
            <font-awesome-icon icon="square-check"/>
            <span class="ml-2">Manage Properties</span>
          </b-dropdown-item>

          <b-dropdown-item @click="handlePublishCheck">
            <Icon2 icon="globe"/>
            <span class="ml-2">Publish check</span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown variant="link" class="ml-2">
          <template slot="button-content">
            <font-awesome-icon icon="tags"/>
            <span class="mx-2">Keywords</span>
          </template>
          <b-dropdown-item @click="showKeywordFilter('label')">
            <Icon2 icon="labels"/>
            <span class="ml-2">Labels</span>
          </b-dropdown-item>
          <b-dropdown-item @click="showKeywordFilter('genre')">
            <Icon2 icon="filter-svgrepo-com"/>
            <span class="ml-2">Genres</span>
          </b-dropdown-item>
          <b-dropdown-item @click="showKeywordFilter('artist')">
            <Icon2 icon="Menu_Users"/>
            <span class="ml-2">Artists</span>
          </b-dropdown-item>
        </b-dropdown>

        <EditLabels :label-type="keywordFilterType" :labels="keywords" @update="updateKeywordFilter($event)" ref="mediaKeywordFilter" :allow-new="false" :allow-manage="false"/>

        <MediaSearchTypeFilter ref="mediaTypeFilter"/>
      </template>
      <template v-else-if="$store.state.media.selectedNodes.length == 1 && $store.state.media.selectedNodes[0].media.category_type != 'root'">
        <template v-if="$store.state.media.categoryIdToCopy == null">
          <b-button @click="handleCopyCategory">
            <Icon2 icon="Copy_id"/>
            Copy
          </b-button>
        </template>
        <b-button-group v-else>
          <b-button @click="$store.commit('media/resetCategoryIdToCopy')" variant="warning">
            <font-awesome-icon icon="times"/>
            Clear
          </b-button>
          <b-button v-if="$store.state.media.categoryIdToCopy != null" @click="handlePasteCategory">
            <Icon2 icon="Copy_id"/>
            Paste
          </b-button>
        </b-button-group>
      </template>
      <template v-if="mediaType != 'category'">
        <PublishStatusFilter ref="publishStatusFilter"/>


        <b-button-group class="ml-3">
          <template v-if="mediaType != 'category'">
            <b-form-select class="mr-3" style="max-width: 250px" id="stats-select-partner" :value="$store.state.media.partnerFilter" @input="$store.dispatch('media/setPartner', $event)" :options="$store.state.media.options.partnerFilter"></b-form-select>
          </template>
          <b-form-select
            style="max-width: 180px"
            :value="mediaType == 'category' ? $store.state.media.categorySortOrder : $store.state.media.sortOrder"
            @input="mediaType == 'category' ? $store.commit('media/putCategorySortOrder', $event) : $store.commit('media/putSortOrder', $event)"
            :options="mediaType == 'category' ? $store.state.media.options.categorySortOrder : $store.state.media.options.sortOrder"
          >
          </b-form-select>

          <template v-if="mediaType != 'category'">
            <b-input-group class="ml-3" style="min-width: 250px">
              <b-form-input v-b-tooltip.hover title="Type to search, or use 'id:' prefix for ID search, 's:' prefix for Slug search, or an absolute URL (starting with https://) for app search" ref="search" v-model="searchInput" placeholder="Type to Search"/>
              <b-input-group-append>
                <div style="margin-top: -0.07rem">
                  <b-button variant="outline-light" :disabled="!searchInput" @click="searchInput = ''"><Icon2 icon="Search_backspace"/></b-button>
                </div>
              </b-input-group-append>
            </b-input-group>
          </template>
        </b-button-group>
      </template>
    </div>
  </div>
</template>

<script>
import PublishStatusFilter from './PublishStatusFilter.vue'
import EditLabels from './EditLabels.vue'
import MediaSearchTypeFilter from './MediaSearchTypeFilter.vue'

export default {
  name: "MediaToolbar",

  components: {
    EditLabels,
    PublishStatusFilter,
    MediaSearchTypeFilter,
  },

  data: function() {
    return {
      debouncedDispatch: null,
      keywordFilterType: "label"
    };
  },

  props: {
    mediaType: String
  },

  computed: {
    searchInput: {
      get() {
        if(this.mediaType == "category") {
          return this.$store.state.media.searchCategoriesString
        }
        else {
          return this.$store.state.media.searchMediaString
        }
      },
      set(value) {
        if(this.mediaType == "category") {
          this.debouncedDispatch('media/searchCategories', value)
        }
        else {
          this.debouncedDispatch('media/searchMedia', value)
        }

      }
    },

    keywords() {
      switch(this.keywordFilterType) {
        case "artist":
          return this.$store.state.media.artistFilter

        case "genre":
          return this.$store.state.media.genreFilter

        case "label":
        default:
          return this.$store.state.media.labelFilter
      }
    }
  },

  methods: {

    focusSearch() {
      this.$refs.search.focus()
    },

    clearSearch() {
      this.searchInput = ''
    },

    handleArchive() {
      if(this.$store.state.media.selectedNodes.length > 0) {
        this.$store.commit('media/updateModal', {archive: {visible: true}})
      }
    },

    handleDuplicate() {
      if(this.$store.state.media.selectedNodes.length == 0) {
        this.$root.app.showAlert("No item selected to duplicate", "warning")
      }
      else if(this.$store.state.media.selectedNodes.length > 1) {
        this.$root.app.showAlert("Can not duplicate more than one item at a time", "warning")
      }
      else {
        this.$store.dispatch('media/duplicateItem', this.$store.state.media.selectedNodes[0].media.id)
      }
    },

    handlePublishCheck() {
      this.$store.dispatch('media/publishCheck')
        .then(resp => {
          this.$store.dispatch('media/publishCheckResults', {
            status: resp.json.data.status,
            results: resp.json.data.results,
            isSaveResult: false
          })
        })
        .catch(error => this.$root.app.showAlert(error.text, "danger"))

    },

    handleCopyCategory() {
      this.$store.commit('media/copySelectedCategory')
    },

    handlePasteCategory() {
      this.$store.dispatch('media/pasteCategory')
        .catch(() => this.$root.app.showAlert("This action is not allowed", "danger"))
    },

    manageMediaLabels() {
      if(this.$store.state.media.selectedNodes.length > 0) {
        this.$store.dispatch('media/manageMediaLabels')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    manageMediaArtists() {
      if(this.$store.state.media.selectedNodes.length > 0) {
        this.$store.dispatch('media/manageMediaArtists')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    manageMediaGenres() {
      if(this.$store.state.media.selectedNodes.length > 0) {
        this.$store.dispatch('media/manageMediaGenres')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    manageMediaProperties() {
      if(this.$store.state.media.selectedNodes.length > 0) {
        this.$store.dispatch('media/manageMediaProperties')
      }
      else {
        this.$root.app.showAlert("No media items selected", "danger")
      }
    },

    showKeywordFilter(type) {
      this.keywordFilterType = type
      this.$refs.mediaKeywordFilter.show(type)
    },

    updateKeywordFilter(keywords) {
      switch(this.keywordFilterType) {
        case "artist":
          this.$store.dispatch('media/setArtistFilter', keywords)
          break

        case "genre":
          this.$store.dispatch('media/setGenreFilter', keywords)
          break

        case "label":
        default:
          this.$store.dispatch('media/setLabelFilter', keywords)
      }
    }

  },

  created() {
    this.debouncedDispatch = this.$_.debounce(this.$store.dispatch, 500)

    this.$root.$on('media-search-focus', this.focusSearch)
    this.$root.$on('media-search-clear-selection', this.clearSearch)
  },

  beforeDestroy() {
    this.$root.$off('media-search-focus', this.focusSearch)
    this.$root.$off('media-search-clear-selection', this.clearSearch)
  }
}
</script>

<style scoped>
</style>
